import type { QueryRow } from "./types";

export const formatTime = (date: Date): string =>
  date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", second: "2-digit" });

export const rowsToParams = (rows: QueryRow[]): Record<string, string> => {
  const params: Record<string, string> = {};
  for (const { key, value } of rows) {
    const k = key.trim();
    const v = value.trim();
    if (k && v) params[k] = v;
  }
  return params;
};
